import { keepPreviousData, useQuery } from '@tanstack/react-query';
import type { DashboardResponse } from '@wrapforce/shared';
import { workspacePath } from '@wrapforce/shared/api-client';
import { api } from '@/lib/api';

export function useDashboard(workspaceId: string | null, locationId?: string) {
  return useQuery({
    queryKey: [workspaceId, 'dashboard', locationId],
    queryFn: () => api.get<DashboardResponse>(workspacePath(workspaceId!, '/dashboard'), { query: { locationId } }),
    enabled: !!workspaceId,
    staleTime: 30_000,
    placeholderData: keepPreviousData,
    refetchInterval: 5 * 60_000,
    refetchIntervalInBackground: false,
  });
}
